import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import InstagramConnected from "./InstagramConnected";
import InstagramSetup from "./InstagramSetup";

interface InstagramHelperProps {
  closeDialog?: () => void;
}

export default function InstagramHelper({ closeDialog }: InstagramHelperProps) {
  const { profile } = useContext(OrganizationUserContext);

  const hasInstagram = profile?.instagramUrl;

  if (hasInstagram) {
    return <InstagramConnected closeDialog={closeDialog} />;
  }

  return <InstagramSetup closeDialog={closeDialog} />;
}
